import type { FC } from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import { getFileUrl } from '@helpers';

interface SuccessPreviewFileProps {
  name: string;
  url?: string;
  onRemove: () => void;
  isLoading?: boolean;
}

export const SuccessPreview: FC<SuccessPreviewFileProps> = ({
  name,
  url,
  onRemove,
  isLoading = false,
}) => {
  const fileUrl = url ? getFileUrl(url) : '';
  return (
    <div className="w-full lg:h-24 py-4 lg:py-5 px-4 lg:px-5 rounded-md flex justify-between gap-4 bg-(--success-S200) relative">
      {isLoading ? (
        <div className="absolute inset-0 flex justify-center items-center bg-[#FAFDFF] border-[--neutral-white-NW800] rounded-md border-2 border-dashed">
          <Loader2 className="h-6 w-6 animate-spin text-(--neutral-black-NB600)" />
        </div>
      ) : (
        <>
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-3">
            {url && (
              <img
                src={fileUrl}
                alt={name}
                className="lg:h-[42px] lg:w-[42px] object-cover rounded"
              />
            )}
            <div className="flex flex-col gap-1 lg:gap-2 items-start">
              <div className="[font-family:var(--font-montserrat)]! [font-size:var(--fs-l4)]! medium text-(--neutral-black-NB1000)">
                {name}
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={onRemove}
            disabled={isLoading}
            className="self-center ml-auto flex h-9 w-9 items-center justify-center rounded-full! bg-(--neutral-black-NB700)/10 text-(--neutral-black-NB700)"
          >
            <Trash2
              className="h-5 w-5 text-(--neutral-black-NB600) cursor-pointer"
              strokeWidth={1.5}
            />
          </button>
        </>
      )}
    </div>
  );
};
